import React from 'react';
import {TextField, MenuItem, Grid} from '@material-ui/core';
import _ from 'lodash';

function SelectWithInput(props) {
  const {selectGridProps, inputGridProps} = props;
  const {selectName, selectValue, selectArray, selectLabel, selectRequired} = props;
  const {inputName, inputValue, inputLabel, inputRequired} = props;
  const {handleChange} = props;

  return (
    <React.Fragment>
      <Grid {...selectGridProps}>
        <TextField
            id={`select-${selectName}`}
            name={selectName}
            label={selectLabel}
            variant='outlined'
            value={selectValue}
            onChange={handleChange}
            select
            fullWidth
            required={selectRequired}
          >
            {selectArray.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
      </Grid>
      {
        _.find(selectArray, {'id': selectValue})?.input || false ?
          <Grid {...inputGridProps}>
            <TextField
                id={`input-${inputName}`}
                key={100}
                name={inputName}
                label={inputLabel}
                variant='outlined'
                onChange={handleChange}
                value={inputValue}
                fullWidth
                required={inputRequired}
              />
          </Grid>
        :
        null
      }
    </React.Fragment>
  )
}

SelectWithInput.defaultProps = {
  selectComponent: (props)=> <div>{props.children}</div>,
  inputComponent: (props)=> <div>{props.children}</div>,
  selectArray: [],
  selectRequired: false,
  inputRequired: false,
}

export default SelectWithInput